<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToPadding'
});
</script>
<template>
	<div class="to-padding" :flex="flex ? flex : null" :style="setStyle" :class="setClass">
		<slot></slot>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { CSSProperties } from 'vue'


export interface Props {
	flex?: boolean
	mode?: string
	value?: string | number
	height?: string
	position?: string
}

const props = withDefaults(defineProps<Props>(), {
	flex: false,
	mode: 'default',
	value: 1,
	height: '',
	position: 'trbl'
})

const hasUnit = (val: string) => /[a-z%]+$/i.test(val)
const setStyle = computed((): CSSProperties => {
	const obj: CSSProperties = {}

	if (String(props.value).trim() && props.mode === 'default') {
		// 分割成各个值
		const padded = String(props.value)
			.trim()
			.split(/\s+/)
			.map(val => {
				// 如果是数字（或纯数字字符串），或末尾无单位，就加 em
				return hasUnit(val) ? val : `${val}em`
			})
			.join(' ')

		obj['--value'] = padded
	}

	if (!props.position.includes('t')) {
		obj.paddingTop = 0
	}
	if (!props.position.includes('r')) {
		obj.paddingRight = 0
	}
	if (!props.position.includes('b')) {
		obj.paddingBottom = 0
	}
	if (!props.position.includes('l')) {
		obj.paddingLeft = 0
	}

	if (props.height && props.height !== 'full') {
		obj.height = isNaN(Number(props.height)) ? props.height : `${props.height}em`
	}

	return obj
})

const setClass = computed(() => {
	const arr: string[] = []
	if (props.mode) {
		arr.push(`mode-${props.mode}`)
	}
	if (props.height && props.height === 'full') {
		arr.push('height-full')
	}
	return arr
})
</script>
